export default __webpack_public_path__ + "static/media/KH.66413c8d.svg";